<template>
  <div>
    <!-- 时间组件开始 -->
    <van-calendar
      color="#29BEBC"
      v-model="show"
      @confirm="onConfirm"
      :show-title="false"
      :show-confirm="false"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <!-- 时间组件结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import moment from "moment";
export default {
  props:{
    date:{
      type:String
    },
    show:{
      type:Boolean
    },
    minDate:{
      
    },
    maxDate:{

    }
  },
  data() {
    return {
      dataTime:this.date,
      showTime: this.show
      // date: moment(this.centralControl.utils.obtainEast8Date()).format(
      //   "YYYY-MM-DD"
      // ),
      // show: false,
      // minDate: new Date(2019, 0, 1),
      // maxDate: this.date,
    };
  },
  watch: {
      date(val) {
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    onConfirm(date) {
      this.showTime = false;
      this.dataTime = this.formatDate(date);
    },
    init() {}
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../assets/stylus/common.styl';

.time-box {
  text-align: center;
  margin: 20px auto 10px;
}

.time-text {
  height: 20px;
  line-height: 20px;
  vertical-align: middle;
  stepTextStyle();
}

.down-img {
  width: 25px;
  vertical-align: middle;
  margin-left: 4px;
  display: inline-block;
}
</style>